import React from 'react'
import DashHeader from '../mini/DashHeader'
import { NavLink } from 'react-router-dom'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useForgotPasswordMutation, useResetPasswordMutation } from '../../redux/services/authApi'
import useCountDown from '../../hooks/useCountDown'
import { toast } from 'react-toastify'
import { ClipLoader } from 'react-spinners'

const EditProfile = () => {

    const [ current, setCurrent ] = useState('')
    const [ newPassword, setNewPassword ] = useState('')
    const [ confirm, setConfirm ] = useState('')
    const curUserEmail = useSelector((state) => state.auth?.user?.email)
    const [ forgotPassword ] = useForgotPasswordMutation()
    const [ resetPassword, { isLoading } ] = useResetPasswordMutation()
    const [timer, timerRunning, runCountdown] = useCountDown(120)

    let handleInput = (e) => {
        switch (e.target.id) {
            case 'current':
            setCurrent(e.target.value);
            break;
            
            case 'new':
            setNewPassword(e.target.value);
            break;
            
            case 'confirm':
            setConfirm(e.target.value);
            break;
            
            default:
            alert('sorry, unknown field');
            break;
        }
    }

    const sendOTP = async () => {
        console.log(curUserEmail)

        runCountdown()
        await forgotPassword({ email: curUserEmail })
            .unwrap()
            .catch((error) => {
                toast.error(error?.data?.message, {
                    position: toast.POSITION.TOP_RIGHT
                })
                console.log('err', error)}
            )
    }

    const submit = async (e) => {
        e.preventDefault()

        if (newPassword !== confirm) 
            return toast.error("Password and confirm passowrd does not match", {
                position: toast.POSITION.TOP_RIGHT
            })

        const fd = {
            email: curUserEmail,
            otp: current,
            newPassword: newPassword
        }
        await resetPassword(fd)
            .unwrap()
            .then((resp) => {
                console.log(resp)
                toast.success("Password reset successful", {
                    position: toast.POSITION.TOP_RIGHT
                })
                setCurrent('')
                setNewPassword('')
                setConfirm('')
            })
            .catch((error) => {
                console.log(error)
                toast.error(error?.data?.error || error?.data?.message, {
                    position: toast.POSITION.TOP_RIGHT
                })
            })
    }

    const tabClasses1 = "text-decoration-none ps-0 p-2 my-2 border-bottom-1 d-md-inline d-inline-block top-tab"
    const tabClasses2 = "text-decoration-none p-2 d-md-inline d-inline-block px-1 my-2 border-bottom-1 top-tab" 
    
    return (
        <>
            <DashHeader title="Admin Settings" />
            <nav className='mt-2 d-flex nav-tab'>
            <NavLink exact={"true"} to={"/dashboard/admin/edit-profile"} className={({ isActive }) => isActive ? tabClasses1+" active-top-tab" : tabClasses1}>
                    Edit Profile
                </NavLink>
                <span className="ps-0 p-2 d-md-inline d-none my-2 border-bottom-1 top-tab">
                </span>
                <NavLink exact={"true"} to={"/dashboard/admin/change-password"} className={({ isActive }) => isActive ? tabClasses2+" active-top-tab" : tabClasses2}>
                    Change Password
                </NavLink>
                <span className="ps-0 p-2 d-md-inline d-none px-5 my-2 border-bottom-1 top-tab">
                </span>
                <span className="ps-0 p-2 d-md-inline d-none px-5 my-2 border-bottom-1 top-tab">
                </span>
            </nav>
            <div className="pull-up m-3">
                <div className="content mt-5 ms-md-5">
                    <form action="">
                        <div className="form-group mb-4">
                            <label htmlFor="current" className="mb-2 fw-normal">Enter OTP</label>
                            <div className="input d-flex align-items-center form-control w-50 w-md-100">
                                <input type="number" id="current" className="w-100 p-2 px-0" onChange={handleInput} value={current} />
                                <button disabled={timerRunning} className="flash-txt otp-btn btn p-0 cursor-pointer" style={{ color: timerRunning ? "#aaa" : null }} onClick={sendOTP}>{timerRunning ? timer : 'Send OTP'}</button>
                            </div>
                        </div>

                    
                        <div className="form-group mb-4">
                            <label htmlFor="new" className="mb-2 fw-normal">New Password</label>
                            <div className="input form-control w-50 w-md-100">
                                <input type="password" id="new" className="w-100 p-2 px-0" onChange={handleInput} value={newPassword} />
                            </div>
                        </div>

                    
                        <div className="form-group mb-4">
                            <label htmlFor="confirm" className="mb-2 fw-normal">Confirm New Password</label>
                            <div className="input form-control w-50 w-md-100">
                                <input type="password" id="confirm" className="w-100 p-2 px-0" onChange={handleInput} value={confirm} />
                            </div>
                        </div>

                        <button onClick={submit} className="btn flash-bg p-2 px-4 fw-bold text-uppercase">{ isLoading ? <ClipLoader size={20} /> : 'change password' }</button>
                    </form>
                </div>
            </div>
        </>
    )
}

export default EditProfile
